import { Typography, Stack, Divider, Box } from '@mui/material';
import { FC } from 'react';
import { useSummaryLines } from './summaryUtils';

export const SummaryHeadingColumn: FC<{ topGutter?: boolean }> = ({ topGutter }) => {
  const lines = useSummaryLines();
  return (
    <Stack sx={{ mt: topGutter ? 5.5 : undefined }}>
      {lines?.map((line) => (
        <Box key={line.key} sx={{ ml: line.level }}>
          {line.isTotal && <Divider />}
          <Typography sx={{ fontSize: 'small', fontWeight: line.isTotal ? 'medium' : undefined }}>{line.label}</Typography>
        </Box>
      ))}
    </Stack>
  );
};
